import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useTheme } from "@mui/material/styles";
import moment from "moment";

const options = {
  scales: {
    yAxes: [
      {
        id: "A",
        type: "linear",
        position: "left"
      },
      {
        id: "B",
        type: "linear",
        gridLines: {
          drawOnChartArea: false // hides grid lines to avoid clutter
        },
        position: "right"
      },
       {
        id: "C",
        type: "linear",
        position: "right",
        gridLines: {
          drawOnChartArea: false // hides grid lines to avoid clutter
        },
      }
    ]
  },
  events: ["click"],
  legend: {
    position: "top",
    labels: {
      boxWidth: 15,
      fontSize: 10,
      fontFamily: "Neutraface2Book"
    }
  }
};

const GraphBookingsDev = props => {
  const theme = useTheme();

  const [dataRevenue, setDataRevenue] = useState([]);
  const [dataCommission, setDataCommission] = useState([]);
  const [labels, setLabels] = useState([]);
  const [dataBookings, setDataBookings] = useState([]);

  useEffect(() => {
    developmentOfBookingsGraph();
  }, [props.bookings]);

  const developmentOfBookingsGraph = () => {
    const startDate = props.dateRangeSelection.startDate;
    const endDate = props.dateRangeSelection.endDate;
    let bookings = [];
    for (let booking of props.bookings) {
      if (booking.status === "booked" || booking.status === "closed") {
        bookings.push(booking);
      }
    }
    let devBookings = [];
    let loopDate = startDate;
    while (loopDate <= endDate) {
      const newBooking = {
        date: moment(loopDate).format("DD.MM.YYYY"),
        totalBookings: 0,
        totalRevenue: 0,
        totalCommission: 0
      };

      devBookings.push(newBooking);
      loopDate = moment(loopDate).add(1, "days");
    }

    // For loop through list of the bookings to fill data
    for (let booking of bookings) {
      for (let devBooking of devBookings) {
        if (moment(booking.created_at).format("DD.MM.YYYY") === devBooking.date) {
          devBooking.totalBookings++;
          devBooking.totalRevenue +=
            booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees);
          devBooking.totalCommission +=
            booking.commission_booking.total_hotel_commission === null
              ? 0
              : parseFloat(booking.commission_booking.total_hotel_commission);
        }
      }
    }

    // Prepare graph options and data
    let dataBookings = [];
    let dataRevenue = [];
    let dataCommission = [];
    let labels = [];

    for (let booking of devBookings) {
      labels.push(booking.date);
      dataRevenue.push(booking.totalRevenue.toFixed(2));
      dataCommission.push(booking.totalCommission.toFixed(2));
      dataBookings.push(booking.totalBookings);
    }
    setLabels(labels);
    setDataRevenue(dataRevenue);
    setDataCommission(dataCommission);
    setDataBookings(dataBookings);
  };

  let data = {
    labels: labels,
    datasets: [
      {
        label: "Revenue",
        backgroundColor: theme.palette.custom.blueBaby,
        data: dataRevenue,
        order: 1,
        yAxisID: "A"
      },
      {
        label: "Commission",
        backgroundColor: theme.palette.custom.blue,
        data: dataCommission,
        order: 2,  
        yAxisID: "B"
      },
      {
        label: "Bookings",
        backgroundColor: theme.palette.custom.turquoiseOpacity05,
        data: dataBookings,
        type: "line",
        order: 3,
       yAxisID: "C"
      }
    ]
  };

  return (
    <div>
      <Bar data={data} options={options} />
    </div>
  );
};

export default GraphBookingsDev;
